import React, { Component, PropTypes } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { graphql, compose, withApollo } from 'react-apollo';
import gql from 'graphql-tag';
import _ from 'lodash';
import {
	SearchBar,
	Subdivision,
	EntityList,
	Switch,
	Tooltip,
	Breadcrumb,
	Pagination,
	Loader,
	Button,
	Badge,
	Alert,
} from './../../components';
import client from '../../lib/frost-web-client';
import VerifyPane from './VerifyPane';
import graphqlLib from './../../lib/graphql-lib';
import { setGlobalMsg } from '../../actions/global-msg';

const VerifySubdivisionPane = withApollo(VerifyPane);

// Import the CSS
import '../../../scss/containers/subdivisions/_list.scss';

export const DEFAULT_LIMIT = 10;

export class SubdivisionList extends Component {
	static propTypes = {
		builderData: PropTypes.object,
		subdivisionsData: PropTypes.object,
		location: PropTypes.object,
		user: PropTypes.shape({
			can: PropTypes.func.isRequired,
			isAdmin: PropTypes.func,
		}).isRequired,
		actions: PropTypes.object,
		toggleZlsEnabled: PropTypes.func,
		togglePaidSubdivision: PropTypes.func,
		togglePaidSubdivisions: PropTypes.func,
		toggleInPersonTour: PropTypes.func,
		toggleVirtualTour: PropTypes.func,
		togglePearlEligibility: PropTypes.func,
		params: PropTypes.object,
		reprovisionTrackedPhoneNumber: PropTypes.func,
		reprocessSubdivisionImages: PropTypes.func,
	};

	csvHeaderMap = {
		PhoneAreaCode: 'areaCode',
		PhonePrefix: 'prefix',
		PhoneSuffix: 'suffix',
		PhoneExtension: 'extension',
	};

	state = {
		showVerifyPane: false,
		selectedSubdivision: {},
		filter: this.props.location.query.filter || '',
		isAllPCToggleLoading: false,
		isAllPearlToggleLoading: false,
		currentAllPCToggleValue: null,
		currentAllPearlToggleValue: null,
		isAlertVisible: false,
		alertMessage: '',
		reprovisionSubdivisions: [],
		uploadDisabled: true,
		reprocessingSubdivisions: [],
	};

	constructor(props) {
		super(props);

		this.handleClosePane = this.handleClosePane.bind(this);
		this.handleClickVerify = this.handleClickVerify.bind(this);
		this.handleReprovision = this.handleReprovision.bind(this);
		this.handleReprocessImages = this.handleReprocessImages.bind(this);
		this.handleSubdivisionPCToggle = this.handleSubdivisionPCToggle.bind(this);
		this.handleSubdivisionZlsToggle = this.handleSubdivisionZlsToggle.bind(this);
		this.handleRowClick = this.handleRowClick.bind(this);
		this.onSearchText = this.onSearchText.bind(this);
		this.onMarkAllPaid = this.onMarkAllPaid.bind(this);
		this.onToggleAllPearlEligibility = this.onToggleAllPearlEligibility.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.toggleFilterUnverified = this.toggleFilterUnverified.bind(this);
		this.toggleFilterZlsTemplateNotConfigured = this.toggleFilterZlsTemplateNotConfigured.bind(
			this,
		);
		this.handleInPersonTourToggle = this.handleInPersonTourToggle.bind(this);
		this.handleVirtualTourToggle = this.handleVirtualTourToggle.bind(this);
		this.handlePearlEligibilityToggle = this.handlePearlEligibilityToggle.bind(this);
		this.errorAlert = this.errorAlert.bind(this);
		this.dismissAlert = this.dismissAlert.bind(this);
	}

	componentWillMount() {
		if (Number.isNaN(+this.props.params.builderId)) {
			this.props.actions.setGlobalMsg('error', 'Invalid builder id');
		}
		if (_.get(this.props, 'builderData.error') || _.get(this.props, 'subdivisionsData.error')) {
			this.props.actions.setGlobalMsg('error', 'Internal Server Error');
		}
	}

	componentWillReceiveProps(nextProps) {
		const { subdivisions } = this.props.subdivisionsData;
		const { subdivisions: nextSubdivisions } = nextProps.subdivisionsData;

		// Account for the case in updating subdivisions where there are no more results
		// in the current subdivision page, where the user should be moved back
		if (subdivisions && subdivisions.numTotal !== nextSubdivisions.numTotal) {
			if (nextSubdivisions.numTotal && !nextSubdivisions.results.length) {
				browserHistory.push({
					...nextProps.location,
					query: {
						...nextProps.location.query,
						page: nextProps.location.query.page - 1,
					},
				});
			}
		}

		if (!_.isEqual(this.props, nextProps)) {
			if (nextProps.builderData.error || this.props.subdivisionsData.error) {
				this.props.actions.setGlobalMsg('error', 'Internal Server Error');
			}
		}
	}

	handleRowClick(subdivision) {
		browserHistory.push(`${this.props.location.pathname}/subdivisions/${subdivision.rawId}`);
	}

	async handleSubdivisionPCToggle(subdivision, isFeedEnabled, isPendingFeedDisablement) {
		await this.props.togglePaidSubdivision(
			subdivision.id,
			isFeedEnabled,
			isPendingFeedDisablement,
		);
	}

	handleSubdivisionZlsToggle(subdivision, isZlsEnabled) {
		this.props.toggleZlsEnabled(subdivision.id, isZlsEnabled);
	}

	handleInPersonTourToggle(subdivision, isTourEnabled) {
		this.props.toggleInPersonTour(subdivision.id, isTourEnabled);
	}

	handleVirtualTourToggle(subdivision, isTourEnabled) {
		this.props.toggleVirtualTour(subdivision.id, isTourEnabled);
	}

	handlePearlEligibilityToggle(subdivision, isPearlEligible) {
		this.props.togglePearlEligibility(subdivision.id, isPearlEligible);
	}

	handleClickVerify(subdivision) {
		this.setState({
			showVerifyPane: true,
			selectedSubdivision: subdivision,
		});
	}

	handleReprovision(e, subdivision) {
		e.preventDefault();

		this.setState(state => ({
			reprovisionSubdivisions: [subdivision.id, ...state.reprovisionSubdivisions],
		}));

		this.setState(async () => {
			await this.props.reprovisionTrackedPhoneNumber(subdivision.rawId);
			this.setState(state => ({
				reprovisionSubdivisions: state.reprovisionSubdivisions.filter(s => {
					s.id !== subdivision.id;
				}),
			}));
			this.props.actions.setGlobalMsg(
				'success',
				`New tracked phone numbers will be provisioned soon for ${subdivision.name}!`,
			);
		});
	}

	handleReprocessImages(e, subdivision) {
		e.preventDefault();

		this.setState(state => ({
			reprocessingSubdivisions: [subdivision.id, ...(state.reprocessingSubdivisions || [])],
		}));

		this.setState(async () => {
			try {
				await this.props.reprocessSubdivisionImages(subdivision.rawId);
				this.props.actions.setGlobalMsg(
					'success',
					`Images for ${subdivision.name} will be reprocessed soon!`,
				);
			} catch (error) {
				this.props.actions.setGlobalMsg(
					'error',
					`Failed to reprocess images: ${error.message}`,
				);
			} finally {
				this.setState(state => ({
					reprocessingSubdivisions: state.reprocessingSubdivisions.filter(
						s => s !== subdivision.id,
					),
				}));
			}
		});
	}

	handleClosePane(shouldRefetchData) {
		if (shouldRefetchData) {
			this.props.subdivisionsData.refetch();
		}
		this.setState({ showVerifyPane: false });
	}

	onSearchText(filter) {
		this.setState({
			filter,
		});

		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page: 1,
				filter,
			},
		});
	}

	async onMarkAllPaid() {
		const {
			builder: {
				id,
				subdivisionCounts: { active, enabled, pendingFeedDisablement },
			},
		} = this.props.builderData;
		const subdivisions = this.props.subdivisionsData;
		const currentAllPCToggleValue = active === enabled - pendingFeedDisablement;

		this.setState({
			currentAllPCToggleValue,
			isAllPCToggleLoading: true,
		});

		try {
			await this.props.togglePaidSubdivisions(id, !currentAllPCToggleValue);
			await subdivisions.refetch();
		} catch (err) {
			this.errorAlert(err.message);
		} finally {
			this.setState({
				isAllPCToggleLoading: false,
				currentAllPCToggleValue: null,
			});
		}
	}

	async onToggleAllPearlEligibility() {
		const {
			builder: { id, defaultPearlEligibility },
		} = this.props.builderData;
		const subdivisions = this.props.subdivisionsData;
		const currentAllPearlToggleValue = defaultPearlEligibility;

		this.setState({
			currentAllPearlToggleValue,
			isAllPearlToggleLoading: true,
		});

		try {
			await this.props.toggleAllPearlEligibility(id, !currentAllPearlToggleValue);
			await subdivisions.refetch();
		} catch (err) {
			this.errorAlert(err.message);
		} finally {
			this.setState({
				isAllPearlToggleLoading: false,
				currentAllPearlToggleValue: null,
			});
		}
	}

	onPageChange(page) {
		browserHistory.push({
			...this.props.location,
			query: {
				...this.props.location.query,
				page,
			},
		});
	}

	toggleFilterZlsTemplateNotConfigured() {
		const routerState = {
			...this.props.location,
			query: {
				...this.props.location.query,
				filterType: 'needsZlsConfig',
				page: 1,
			},
		};

		// Remove the `filterType` parameter if we're currently showing subdivisions
		// with ZLS template not configured
		if (this.props.location.query.filterType === 'needsZlsConfig') {
			delete routerState.query.filterType;
		}

		browserHistory.push(routerState);
	}

	toggleFilterUnverified() {
		const routerState = {
			...this.props.location,
			query: {
				...this.props.location.query,
				filterType: 'unverified',
				page: 1,
			},
		};

		// Remove the `filterType` parameter if we're currently showing unverified subdivisions
		if (this.props.location.query.filterType === 'unverified') {
			delete routerState.query.filterType;
		}

		browserHistory.push(routerState);
	}

	renderTooltipText({ title, text }) {
		return (
			<div>
				{title && <div className="tooltip-title">{title}</div>}
				<div className="tooltip-text">{text}</div>
			</div>
		);
	}

	errorAlert(message) {
		this.setState({
			isAlertVisible: true,
			alertMessage: message,
		});
	}

	dismissAlert() {
		this.setState({ isAlertVisible: false });
	}

	handleContactsSubmit(e) {
		e.preventDefault();
		const [file] = document.querySelector('input[id=subdivisionContactsCsv]').files;
		const reader = new FileReader();

		reader.addEventListener(
			'load',
			e => {
				let fileContent = e.target.result;
				let contacts = this.csvToJson(fileContent);
				let builder = this.props.builderData.builder;

				client
					.post(`/api/builders/${builder.rawId}/upload-contacts`, contacts)
					.then(response => {
						if (response.ok) {
							if (response.body.length == 0) {
								this.props.actions.setGlobalMsg('success', 'Upload successful.');
							} else {
								this.props.actions.setGlobalMsg('error', response.body.join('; '));
							}
						} else {
							this.props.actions.setGlobalMsg(
								'error',
								'Internal Error, please check file format and contact dev team.',
							);
						}
						return response;
					});
			},
			false,
		);

		if (file) {
			reader.readAsText(file);
		}
	}

	handleFileSelect(e) {
		e.preventDefault();
		var filename = document.getElementById('subdivisionContactsCsv').value;
		const submitButton = document.getElementById('submitSubdivisionFallbackContacts');
		this.setState({ uploadDisabled: !filename });
	}

	csvToJson(csv) {
		var lines = this.csvToArray(csv);
		var result = {};

		if (lines.length < 2) {
			return JSON.stringify(result);
		}
		var headers = lines[0];
		var subdivisionNumberHeaderIdx = headers.indexOf('SubdivisionNumber');

		for (var i = 1; i < lines.length; i++) {
			var phone = {};
			var currentline = lines[i];
			var subdivisionNumber = currentline[subdivisionNumberHeaderIdx];

			if (subdivisionNumber) {
				// to Phone parts
				for (var j = 0; j < headers.length; j++) {
					if (currentline[j] && this.csvHeaderMap[headers[j]]) {
						var part = currentline[j].trim();
						phone[this.csvHeaderMap[headers[j]]] =
							part && part.length > 0 ? part : null;
					}
				}

				if (!(subdivisionNumber in result)) {
					result[subdivisionNumber] = [];
				} else if (result[subdivisionNumber].length > 2) {
					continue;
				}
				result[subdivisionNumber].push(phone);
			}
		}
		return JSON.stringify(result);
	}

	csvToArray(strData, strDelimiter = ',') {
		var objPattern = new RegExp(
			// Delimiters.
			'(\\' +
				strDelimiter +
				'|\\r?\\n|\\r|^)' +
				// Quoted fields.
				'(?:"([^"]*(?:""[^"]*)*)"|' +
				// Standard fields.
				'([^"\\' +
				strDelimiter +
				'\\r\\n]*))',
			'gi',
		);
		var arrData = [[]];
		var arrMatches = null;

		while ((arrMatches = objPattern.exec(strData))) {
			var strMatchedDelimiter = arrMatches[1];
			if (strMatchedDelimiter.length && strMatchedDelimiter !== strDelimiter) {
				// Since we have reached a new row of data,
				// add an empty row to our data array.
				arrData.push([]);
			}

			var strMatchedValue;
			if (arrMatches[2]) {
				// quoted value.
				strMatchedValue = arrMatches[2].replace(new RegExp('""', 'g'), '"');
			} else {
				// non-quoted value.
				strMatchedValue = arrMatches[3];
			}
			arrData[arrData.length - 1].push(strMatchedValue);
		}
		return arrData;
	}

	render() {
		if (
			!this.props.builderData ||
			this.props.builderData.error ||
			this.props.subdivisionsData.error
		) {
			return null;
		}

		if (this.props.builderData.loading) {
			return <Loader overlay />;
		}

		const corporation = this.props.builderData.builder.corporation;
		const builder = this.props.builderData.builder;
		const { active, enabled, pendingFeedDisablement } = builder.subdivisionCounts;
		const subdivisions = this.props.subdivisionsData.subdivisions || {};
		const query = this.props.location.query;
		const shouldMarkAllEnabled =
			this.state.currentAllPCToggleValue === null
				? active === enabled - pendingFeedDisablement
				: this.state.currentAllPCToggleValue;
		const shouldMarkAllPearlEligible =
			this.state.currentAllPearlToggleValue === null
				? builder.defaultPearlEligibility
				: this.state.currentAllPearlToggleValue;
		let breadcrumbs = [
			{ url: '/corporations', label: 'Corporations' },
			{ url: '/' + corporation.rawId, label: corporation.name },
			{ url: '/builders/' + builder.rawId, label: builder.name },
		];

		const { alertMessage, isAlertVisible } = this.state;
		const pagination = {
			pages: {
				total: subdivisions.numTotal ? Math.ceil(subdivisions.numTotal / DEFAULT_LIMIT) : 0,
				current: Number(query.page) || 1,
			},
		};

		return (
			<div className="wrapper">
				<Breadcrumb paths={breadcrumbs} />
				<div className="container subdivision-list">
					<If condition={isAlertVisible}>
						<Alert style="error" canDismiss onClick={this.dismissAlert}>
							{`An error occurred processing your request${
								alertMessage !== '' ? `: ${alertMessage}` : ''
							}. Please refresh and try again.`}
						</Alert>
					</If>
					<div className="row row-align-center">
						<If condition={builder.brandLogoMed}>
							<img className="builder-logo" src={builder.brandLogoMed} />
						</If>
						<h1>{builder.brandName}</h1>
					</div>
					<div className="row">
						<div className="cell builder-info">
							<div className="titles">Division Number</div>
							<div>{builder.number}</div>
						</div>

						<div className="cell builder-info">
							<div className="titles">Default Leads Email</div>
							<div>{builder.email}</div>
						</div>
					</div>
					<div className="row">
						<div className="cell builder-info">
							<div className="titles">Reporting Name</div>
							<div>{builder.name}</div>
						</div>

						<div className="cell builder-info">
							<div className="titles">Website URL</div>
							<div className="web-url">{builder.website}</div>
						</div>
					</div>
					<div className="row line" />
					<div className="row">
						<div className="titles">Pearl Pilot Extra Contacts Upload</div>
						<form className="row file-upload-form">
							<input
								type="file"
								id="subdivisionContactsCsv"
								onChange={e => this.handleFileSelect(e)}
							/>
							<input
								type="submit"
								id="submitSubdivisionFallbackContacts"
								disabled={this.state.uploadDisabled}
								onClick={e => this.handleContactsSubmit(e)}
							/>
						</form>
					</div>
					<div className="row line" />
					<div>
						<div className="row" id="toggle-search-row">
							<div className="cell">
								<If
									condition={
										subdivisions.results &&
										subdivisions.results.length &&
										this.props.user.can('set-paid-status') &&
										!query.filterType &&
										!query.filter
									}>
									<span>Mark All PC Classic Syndication</span>
									<Switch
										onLabel="On"
										offLabel="Off"
										className={`toggle-all-pc`}
										name="mark-all-switch"
										checked={shouldMarkAllEnabled}
										onChange={this.onMarkAllPaid}
										isLoading={this.state.isAllPCToggleLoading}
									/>
									{!this.state.isAllPCToggleLoading &&
										pendingFeedDisablement > 0 && (
											<Tooltip
												key="all-pc-pending"
												position="right"
												style="all-pc-pending"
												text={this.renderTooltipText({
													title: 'Active or Pending ZLS listings',
													text:
														'One or more communities will be updated to Unpaid automatically once there are no more active ZLS listings',
												})}>
												<img src="/assets/img/timer.svg" />
											</Tooltip>
										)}
								</If>
								<If
									condition={
										subdivisions.results &&
										subdivisions.results.length &&
										this.props.user.isAdmin()
									}>
									<span>| Mark All Pearl Management</span>
									<Switch
										onLabel="On"
										offLabel="Off"
										className={`toggle-all-pc`}
										name="mark-all-pearl-switch"
										checked={shouldMarkAllPearlEligible}
										onChange={this.onToggleAllPearlEligibility}
										isLoading={this.state.isAllPearlToggleLoading}
									/>
								</If>
							</div>
							<div className="cell justify-center">
								<Loader
									visible={
										!this.state.isAllPCToggleLoading &&
										this.props.subdivisionsData.loading
									}
								/>
							</div>
							<div className="justify-center filter-buttons">
								<Button
									onClick={this.toggleFilterZlsTemplateNotConfigured}
									size="small"
									style={
										query.filterType === 'needsZlsConfig' ? '' : 'gray-border'
									}>
									Needs ZLS Config
									<Badge
										shape="square"
										style={
											query.filterType === 'needsZlsConfig' ? 'white' : ''
										}>
										{builder.loading
											? '0'
											: builder.subdivisionCounts.zlsTemplateNotConfigured}
									</Badge>
								</Button>
								<Button
									onClick={this.toggleFilterUnverified}
									size="small"
									style={query.filterType === 'unverified' ? '' : 'gray-border'}>
									Needs Verification
									<Badge
										shape="square"
										style={query.filterType === 'unverified' ? 'white' : ''}>
										{builder.loading
											? '0'
											: builder.subdivisionCounts.unverified}
									</Badge>
								</Button>
							</div>
							<div className="cell justify-right">
								<SearchBar value={this.state.filter} onEnter={this.onSearchText} />
							</div>
						</div>
					</div>

					<If condition={subdivisions.results}>
						<Choose>
							<When condition={subdivisions.results.length > 0}>
								<EntityList>
									{_.map(subdivisions.results, subdivision => (
										<Subdivision
											key={subdivision.id}
											subdivision={subdivision}
											onClick={this.handleRowClick}
											onClickVerify={this.handleClickVerify}
											onReprovisionClick={this.handleReprovision}
											onReprocessImagesClick={this.handleReprocessImages}
											onPCToggle={this.handleSubdivisionPCToggle}
											onZlsToggle={this.handleSubdivisionZlsToggle}
											onInPersonTourToggle={this.handleInPersonTourToggle}
											onVirtualTourToggle={this.handleVirtualTourToggle}
											onPearlEligibilityToggle={
												this.handlePearlEligibilityToggle
											}
											onError={this.errorAlert}
											user={this.props.user}
										/>
									))}
								</EntityList>
							</When>
							<When condition={subdivisions.results.length === 0}>
								<div>
									<p>No results found.</p>
								</div>
							</When>
						</Choose>
					</If>

					<If condition={pagination.pages.total > 1}>
						<Pagination
							totalPages={pagination.pages.total}
							currentPage={pagination.pages.current}
							onPageChange={this.onPageChange}
						/>
					</If>

					<VerifySubdivisionPane
						builderId={builder.id}
						onClose={this.handleClosePane}
						visible={this.state.showVerifyPane}
						listFilterType={this.props.location.query.filterType}
						subdivision={this.state.selectedSubdivision}
						title={this.state.selectedSubdivision.name}
					/>
				</div>
			</div>
		);
	}
}

export function getSubdivisionFilters(props) {
	const builderId = graphqlLib.encodeId('builder', props.params.builderId);

	let filter = {
		active: true,
		builderId: { eq: builderId },
	};

	if (props.location.query.filterType === 'needsZlsConfig') {
		filter = {
			zlsTemplateConfigured: false,
			builderId: { eq: builderId },
		};
	}

	if (props.location.query.filterType === 'unverified') {
		filter = {
			active: null,
			isVerified: { eq: false },
			builderId: { eq: builderId },
		};
	}

	if (props.location.query.filter) {
		filter.query = '%' + props.location.query.filter + '%';
	}

	return filter;
}

export function getOffset(props) {
	let offset = 0;
	const limit = props.location.query.limit || DEFAULT_LIMIT;

	if (props.location.query.page) {
		offset = (parseInt(props.location.query.page, 10) - 1) * limit;
	}

	return offset;
}

export const builderQuery = gql`
	query fetchBuilder($builderId: EncodedID!) {
		builder(id: $builderId) {
			id
			rawId: id(raw: true)
			name
			number
			brandName
			brandLogoMed
			email
			website
			defaultPearlEligibility
			corporation {
				id
				rawId: id(raw: true)
				name
			}
			subdivisionCounts {
				active
				enabled
				unverified
				zlsTemplateNotConfigured
				pendingFeedDisablement
				pearlEligible
			}
		}
	}
`;

export const subdivisionsQuery = gql`
	query fetchSubdivisions($filter: SubdivisionFilters!, $limit: Int!, $skip: Int!) {
		subdivisions(filter: $filter, limit: $limit, skip: $skip) {
			...SubdivisionResults
		}
	}
	${Subdivision.fragments.subdivision}
`;

export const togglePaidSubdivisionMutation = gql`
	mutation updateSubdivision(
		$id: EncodedID!
		$isFeedEnabled: Boolean
		$isPendingFeedDisablement: Boolean
		$isZlsEnabled: Boolean
	) {
		updateSubdivision(
			input: {
				id: $id
				isFeedEnabled: $isFeedEnabled
				isPendingFeedDisablement: $isPendingFeedDisablement
				isZlsEnabled: $isZlsEnabled
			}
		) {
			id
			isFeedEnabled
			isPendingFeedDisablement
			isZlsEnabled
			builder {
				id
				subdivisionCounts {
					enabled
				}
			}
		}
	}
`;

export const togglePaidSubdivisionsMutation = gql`
	mutation updateSubdivisions($builderId: EncodedID!, $isFeedEnabled: Boolean!) {
		updateSubdivisions(
			conditions: { builderId: { eq: $builderId }, active: true }
			input: { isFeedEnabled: $isFeedEnabled }
		)
	}
`;

export const toggleInPersonTourMutation = gql`
	mutation updateSubdivision($id: EncodedID!, $isTourEnabled: Boolean!) {
		updateSubdivision(input: { id: $id, isTourEnabled: $isTourEnabled }) {
			id
			isTourEnabled
		}
	}
`;

export const toggleVirtualTourMutation = gql`
	mutation updateSubdivision($id: EncodedID!, $isVirtualTourEnabled: Boolean!) {
		updateSubdivision(input: { id: $id, isVirtualTourEnabled: $isVirtualTourEnabled }) {
			id
			isVirtualTourEnabled
		}
	}
`;

export const togglePearlEligibilityMutation = gql`
	mutation updateSubdivision($id: EncodedID!, $isPearlEligible: Boolean!) {
		updateSubdivision(input: { id: $id, isPearlEligible: $isPearlEligible }) {
			id
			isPearlEligible
		}
	}
`;

export const toggleAllPearlEligibilityMutation = gql`
	mutation updateSubdivisions($builderId: EncodedID!, $isPearlEligible: Boolean!) {
		updateSubdivisions(
			conditions: { builderId: { eq: $builderId }, active: true }
			input: { isPearlEligible: $isPearlEligible }
		)
		updateBuilder(input: { id: $builderId, defaultPearlEligibility: $isPearlEligible }) {
			id
			defaultPearlEligibility
		}
	}
`;

export const reprovisionTrackedPhoneNumberMutation = gql`
	mutation reprovisionTrackedPhoneNumberMutation($id: EncodedID!) {
		reprovisionTrackedPhoneNumber(id: $id) {
			rawUniqueId: uniqueId(raw: true)
		}
	}
`;

export const reprocessSubdivisionImagesMutation = gql`
	mutation reprocessSubdivisionImagesMutation($id: EncodedID!) {
		updateSubdivisionImages(id: $id) {
			id
		}
	}
`;

export default compose(
	connect(
		state => ({
			user: state.auth.user,
		}),
		dispatch => ({
			actions: {
				setGlobalMsg: bindActionCreators(setGlobalMsg, dispatch),
			},
		}),
	),
	graphql(builderQuery, {
		name: 'builderData',
		skip: props => Number.isNaN(+props.params.builderId),
		options: ownProps => ({
			fetchPolicy: 'network-only',
			variables: {
				builderId: graphqlLib.encodeId('builder', ownProps.params.builderId),
			},
		}),
	}),
	graphql(subdivisionsQuery, {
		name: 'subdivisionsData',
		skip: props => Number.isNaN(+props.params.builderId),
		options: ownProps => ({
			fetchPolicy: 'network-only',
			variables: {
				filter: getSubdivisionFilters(ownProps),
				limit: ownProps.location.query.limit || DEFAULT_LIMIT,
				skip: getOffset(ownProps),
			},
		}),
	}),
	graphql(togglePaidSubdivisionMutation, {
		props: ({ mutate }) => ({
			togglePaidSubdivision: (id, isFeedEnabled, isPendingFeedDisablement) =>
				mutate({
					variables: { id, isFeedEnabled, isPendingFeedDisablement },
					refetchQueries: ['fetchBuilder'],
				}),
			toggleZlsEnabled: (id, isZlsEnabled) =>
				mutate({
					variables: { id, isZlsEnabled },
					refetchQueries: ['fetchBuilder'],
				}),
		}),
	}),
	graphql(togglePaidSubdivisionsMutation, {
		props: ({ mutate }) => ({
			togglePaidSubdivisions: (builderId, isFeedEnabled) =>
				mutate({
					variables: { builderId, isFeedEnabled },
					refetchQueries: ['fetchBuilder'],
				}),
		}),
	}),
	graphql(toggleInPersonTourMutation, {
		props: ({ mutate }) => ({
			toggleInPersonTour: (id, isTourEnabled) =>
				mutate({
					variables: { id, isTourEnabled },
				}),
		}),
	}),
	graphql(toggleVirtualTourMutation, {
		props: ({ mutate }) => ({
			toggleVirtualTour: (id, isVirtualTourEnabled) =>
				mutate({
					variables: { id, isVirtualTourEnabled },
				}),
		}),
	}),
	graphql(togglePearlEligibilityMutation, {
		props: ({ mutate }) => ({
			togglePearlEligibility: (id, isPearlEligible) =>
				mutate({
					variables: { id, isPearlEligible },
				}),
		}),
	}),
	graphql(toggleAllPearlEligibilityMutation, {
		props: ({ mutate }) => ({
			toggleAllPearlEligibility: (builderId, isPearlEligible) =>
				mutate({
					variables: { builderId, isPearlEligible },
					refetchQueries: ['fetchBuilder'],
				}),
		}),
	}),
	graphql(reprovisionTrackedPhoneNumberMutation, {
		props: ({ mutate }) => ({
			reprovisionTrackedPhoneNumber: subdivisionId =>
				mutate({
					variables: {
						id: graphqlLib.encodeId('subdivision', subdivisionId),
					},
				}),
		}),
	}),
	graphql(reprocessSubdivisionImagesMutation, {
		props: ({ mutate }) => ({
			reprocessSubdivisionImages: subdivisionId =>
				mutate({
					variables: {
						id: graphqlLib.encodeId('subdivision', subdivisionId),
					},
				}),
		}),
	}),
)(SubdivisionList);



// WEBPACK FOOTER //
// ./src/assets/js/containers/subdivisions/List.js